import React from 'react';
import { Collapse } from 'antd';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Checkbox from 'antd/lib/checkbox';

const { Panel } = Collapse;

const RemissionList = (props) => {
    const genExtra = (remission) => (
        <div>
          <Checkbox
            checked={props.selectedRemissions.includes(remission.uuid)} 
            onChange={() => props.updateDataOrdersChecked(remission)} 
          />
          <IconButton
            color="primary"
            aria-label="pdf"
            onClick={(e) =>{ props.displayPDF(remission);
              e.stopPropagation();
            }}
          >
            <PictureAsPdfIcon />
          </IconButton>
          <IconButton
            color="error"
            aria-label="delete"
            onClick={(e) => {props.deleteRemission(remission);
              e.stopPropagation();
            }}
          >
            <DeleteIcon />
          </IconButton>
        </div>
      );

  return (
    <Collapse defaultActiveKey={[]}>
      {props.data.map((remission, key) => (
        <Panel
          style={{ backgroundColor: '#DFFFD9', fontWeight: 'normal' }}
          key={key + 1}
          extra={genExtra(remission)}
          header={
            <>
              <strong style={{ marginRight: '20px' }}>{`Remisión: ${remission.id}`}</strong>
              <strong>{`Cliente: ${remission.remissionDetails[0].orderDetail.productPrice.client.name}`}</strong>
              <span style={{ marginLeft: '20px' }}>{`Fecha: ${remission.date}`}</span>
            </>
          }
        >
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
                Dirección de envío: {remission.remissionDetails[0].orderDetail.productPrice.client.address}
              </span>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={2} md={2}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Producto</span>
              </Grid>
              <Grid item xs={2} md={2}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Color</span>
              </Grid>
              <Grid item xs={1} md={1}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Cantidad</span>
              </Grid>
              <Grid item xs={1} md={1}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Medida</span>
              </Grid>
              <Grid item xs={2} md={2}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Proceso Asignado</span>
              </Grid>
              <Grid item xs={2} md={2}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Precio</span>
              </Grid>
              <Grid item xs={2} md={2}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Sub Total</span>
              </Grid>
            </Grid>
            {remission.remissionDetails.map((rd, key) => (
              <Grid key={key + 'itemOd'} container spacing={1}>
                <Grid item xs={2} md={2}>
                  <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                    {rd.orderDetail.productPrice.product.ref}
                  </span>
                </Grid>
                <Grid item xs={2} md={2}>
                  <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                    {rd.orderDetail.color.cod}
                  </span>
                </Grid>
                <Grid item xs={1} md={1}>
                  <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                    {rd.orderDetail.quantity}
                  </span>
                </Grid>
                <Grid item xs={1} md={1}>
                  <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                    {rd.orderDetail.type_quantity}
                  </span>
                </Grid>
                <Grid item xs={2} md={2}>
                  <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                    {rd.orderDetail.cod_process ? rd.orderDetail.cod_process:''}
                  </span>
                </Grid>
                <Grid item xs={2} md={2}>
                  <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                    {rd.orderDetail.price ? rd.orderDetail.price : ''}
                  </span>
                </Grid>
                <Grid item xs={2} md={2}>
                  <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                    {rd.orderDetail.price ? rd.orderDetail.price * rd.orderDetail.quantity : ''}
                  </span>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Panel>
      ))}
    </Collapse>
  );
};

export default RemissionList;
